import React from 'react';
import { Helmet } from 'react-helmet';

const RedirectScreen = () => (
  <div
    style={{
      height: '100vh',
      width: '100vw',
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: '#ffffff',
      zIndex: 9999,
    }}
  />
);

export const KlookRedirect = () => {
  React.useEffect(() => {
    window.location.href =
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1024317&k_site=https%3A%2F%2Fwww.klook.com%2F';
  }, []);

  return (
    <>
      <Helmet>
        <title>מזרח ללא גבולות - Klook</title>
        <meta property="og:title" content="מזרח ללא גבולות - Klook" />
        <meta
          property="og:description"
          content="הזמינו אטרקציות, סיורים וחוויות במזרח אסיה במחירים הטובים ביותר"
        />
        <meta property="og:image" content="/images/redirects/klookLogo.png" />
        <meta property="og:url" content="https://www.lelo-gvulot.com/klook" />
        <meta property="og:type" content="website" />
      </Helmet>
      <RedirectScreen />
    </>
  );
};

export const GetYourGuideRedirect = () => {
  React.useEffect(() => {
    window.location.href =
      'https://www.getyourguide.com/s?partner_id=Q3VFO4H&utm_medium=online_publisher&et=505196&lc=169';
  }, []);
  return (
    <>
      <Helmet>
        <title>מזרח ללא גבולות - GetYourGuide</title>
        <meta property="og:title" content="מזרח ללא גבולות - GetYourGuide" />
        <meta
          property="og:description"
          content="הזמינו אטרקציות, סיורים וחוויות במזרח אסיה במחירים הטובים ביותר"
        />
        <meta
          property="og:image"
          content="/images/redirects/getYourGuideLogo.png"
        />
        <meta
          property="og:url"
          content="https://www.lelo-gvulot.com/get-your-guide"
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <RedirectScreen />
    </>
  );
};

export const TwelveGoRedirect = () => {
  React.useEffect(() => {
    window.location.href = 'https://12go.asia/?z=11721284';
  }, []);

  return (
    <>
      <Helmet>
        <title>מזרח ללא גבולות - 12Go</title>
        <meta property="og:title" content="מזרח ללא גבולות - 12Go" />
        <meta
          property="og:description"
          content="הזמינו כרטיסי רכבת, אוטובוס ומעבורת במזרח אסיה במחירים הטובים ביותר"
        />
        <meta property="og:image" content="/images/redirects/12GoLogo.png" />
        <meta property="og:url" content="https://www.lelo-gvulot.com/12go" />
        <meta property="og:type" content="website" />
      </Helmet>
      <RedirectScreen />
    </>
  );
};

export const AiraloNewCustomersRedirect = () => {
  React.useEffect(() => {
    window.location.href = 'https://airalo.pxf.io/c/6169857/2071037/15608';
  }, []);

  return (
    <>
      <Helmet>
        <title>מזרח ללא גבולות - Airalo</title>
        <meta property="og:title" content="מזרח ללא גבולות - Airalo" />
        <meta
          property="og:description"
          content="קנו חבילת גלישה בחו״ל עם 15% הנחה לרוכשים חדשים באיירלו"
        />
        <meta property="og:image" content="/images/redirects/airaloLogo.png" />
        <meta property="og:url" content="https://www.lelo-gvulot.com/airalo" />
        <meta property="og:type" content="website" />
      </Helmet>
      <RedirectScreen />
    </>
  );
};

export const AiraloExistingCustomersRedirect = () => {
  React.useEffect(() => {
    window.location.href = 'https://airalo.pxf.io/c/6169857/2071038/15608';
  }, []);

  return (
    <>
      <Helmet>
        <title>מזרח ללא גבולות - Airalo</title>
        <meta property="og:title" content="מזרח ללא גבולות - Airalo" />
        <meta
          property="og:description"
          content="קנו חבילת גלישה בחו״ל עם 10% הנחה ללקוחות קיימים באיירלו"
        />
        <meta property="og:image" content="/images/redirects/airaloLogo.png" />
        <meta property="og:url" content="https://www.lelo-gvulot.com/airalo" />
        <meta property="og:type" content="website" />
      </Helmet>
      <RedirectScreen />
    </>
  );
};

export const TripRedirect = () => {
  React.useEffect(() => {
    window.location.href = 'https://www.trip.com/t/VNX888eQXP2';
  }, []);

  return (
    <>
      <Helmet>
        <title>מזרח ללא גבולות - Trip.com</title>
        <meta property="og:title" content="מזרח ללא גבולות - Trip.com" />
        <meta
          property="og:description"
          content="הזמינו טיסות, מלונות, אטרקציות וסיורים במחירים האטרקטיביים ביותר"
        />
        <meta property="og:image" content="/images/redirects/tripLogo.png" />
        <meta property="og:url" content="https://www.lelo-gvulot.com/trip" />
        <meta property="og:type" content="website" />
      </Helmet>
      <RedirectScreen />
    </>
  );
};
